var Handlebars = require("C:\\Users\\surunzi\\project\\eruda-dom\\node_modules\\handlebars\\runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<span class=\"eruda-html-comment\">&lt;!-- "
    + container.escapeExpression(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"value","hash":{},"data":data}) : helper)))
    + " --&gt;</span>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/htmlComment.hbs
// module id = 119
// module chunks = 0